import { Injectable } from '@angular/core';
import { EntityType } from '@epicuro-next/data/engagement/engagement-models';
import { APP_PRIVATE_PATHS } from '@epicuro-next/navigation/constants';
import { go, selectUrl } from '@epicuro-next/state/router-store';
import { isNonNullish } from '@epicuro-next/utilities';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { filter, map, switchMap, withLatestFrom } from 'rxjs/operators';

import * as actions from '../actions';
import { selectActiveReference } from '../news-feed.selectors';

/** News feed fetch effects */
@Injectable()
export class NavigationEffects {
  /** Navigate internal action effect if news feed is loaded not in the iframe */
  public handleNavigate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.navigate),
      map(({ data }) => ({ id: data.referenceId, type: data.type })),
      switchMap(({ type, id }) => [
        go({
          commands: [
            APP_PRIVATE_PATHS.browse.path,
            type === EntityType.LookBook
              ? APP_PRIVATE_PATHS.shopTheLook.path
              : APP_PRIVATE_PATHS.productList.path,
            id,
          ],
        }),
        actions.setActiveReference({
          reference: { id: id as string, type },
        }),
      ]),
    ),
  );

  public handleClosingList$ = createEffect(() =>
    this.store.pipe(select(selectUrl)).pipe(
      filter(
        (url) => !!url && !url.includes(APP_PRIVATE_PATHS.productList.path),
      ),
      withLatestFrom(this.store.pipe(select(selectActiveReference))),
      filter(([, reference]) => isNonNullish(reference)),
      map(() => actions.setActiveReference({ reference: null })),
    ),
  );

  /** Dependencies */
  constructor(private actions$: Actions, private store: Store) {}
}
